var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.talentLoading,
          expression: "talentLoading",
        },
      ],
      staticStyle: { "min-height": "200px" },
    },
    [
      _vm.achData && _vm.achData.length && !_vm.talentLoading
        ? _c(
            "div",
            _vm._l(_vm.achData, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "person-item",
                  on: {
                    click: function ($event) {
                      return _vm.toPaperDetail(item.id)
                    },
                  },
                },
                [
                  _c("div", { staticStyle: { "margin-left": "8px" } }, [
                    _c("div", { staticClass: "person-name" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "item-left flex-wrap",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("label", { staticClass: "no-wrap" }, [
                          _vm._v("作者："),
                        ]),
                        _vm._l(
                          item.authors.length > 3
                            ? item.authors.slice(0, 3)
                            : item.authors,
                          function (auther, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticClass: "item-right",
                                staticStyle: {
                                  "margin-right": "9px",
                                  "flex-shrink": "0",
                                },
                                attrs: { title: auther.scholarName },
                              },
                              [
                                _c(
                                  "el-avatar",
                                  {
                                    attrs: {
                                      fit: "cover",
                                      size: 14,
                                      src: auther.avatarUrl,
                                    },
                                    on: { error: _vm.errorHandler },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" " + _vm._s(auther.scholarName) + " "),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "item-left ellipsis" }, [
                      _c("label", [_vm._v("出版物：")]),
                      _c("span", { staticClass: "item-right ellipsis" }, [
                        _vm._v(_vm._s(item.venue || "-")),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-left ellipsis" }, [
                      _c("label", [_vm._v("引用次数：")]),
                      _c(
                        "span",
                        {
                          staticClass: "item-right ellipsis",
                          staticStyle: { "margin-right": "9px" },
                        },
                        [_vm._v(_vm._s(item.citationNum || 0))]
                      ),
                      _c("label", [_vm._v("发表时间：")]),
                      _c("span", { staticClass: "item-right ellipsis" }, [
                        _vm._v(_vm._s(item.year || "-")),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _c("el-empty"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }